import { css } from '@emotion/react'
import { colors, font, Tooltip } from 'plume-ui'

type Props = {
  children: any
  disabled?: boolean
  isLoading: boolean
  tooltip?: string
  label: string
  onClick?: () => any
}

export const HeaderButton: React.FC<Props> = ({
  disabled,
  isLoading,
  onClick,
  tooltip,
  label,
  children,
}) => (
  <>
    <Tooltip label={tooltip || ''} className="download-button-tooltip">
      <div
        className={disabled ? 'header-button disabled' : 'header-button'}
        onClick={() => onClick && !disabled && onClick()}
        css={css`
          text-align: center;
          padding: 6px 12px;
          cursor: pointer;
          vertical-align: bottom;
          transition: 0.15s;
          &:hover {
            background: rgba(0, 0, 0, 0.03);
          }
          opacity: ${isLoading ? 0.5 : 1};
        `}
      >
        {children}
        <div
          css={css`
            font-size: 11px;
            font-style: normal;
            font-weight: ${font.weight.normal};
            font-size: 11px;
            line-height: 100%;
            display: flex;
            align-items: center;
            text-align: center;
            letter-spacing: 0.02em;
            color: ${colors.textStrong};
            margin-top: 5.25px;
          `}
        >
          {label}
        </div>
      </div>
    </Tooltip>
  </>
)
